import { createGlobalStyle } from 'styled-components';

import NotoSansBold from './NotoSans-Bold.ttf';
import NotoSansBoldItalic from './NotoSans-BoldItalic.ttf';
import NotoSansItalic from './NotoSans-Italic.ttf';
import NotoSansLight from './NotoSans-Light.ttf';
import NotoSansRegular from './NotoSans-Regular.ttf';
import NotoSansSemiBold from './NotoSans-SemiBold.ttf';
import NotoSansSemiBoldItalic from './NotoSans-SemiBoldItalic.ttf';

export default createGlobalStyle`

  @font-face {
    font-family: 'NotoSans';
    src: local('NotoSans'), url(${NotoSansLight}) format('truetype');
    font-weight: 300;
    font-style: normal;
  } 
  
  @font-face {
    font-family: 'NotoSans';
    src: local('NotoSans'), url(${NotoSansRegular}) format('truetype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'NotoSans';
    src: local('NotoSans'), url(${NotoSansItalic}) format('truetype');
    font-weight: 400;
    font-style: italic;
  }


  @font-face {
    font-family: 'NotoSans';
    src: local('NotoSans'), url(${NotoSansSemiBold}) format('truetype');
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: 'NotoSans';
    src: local('NotoSans'), url(${NotoSansSemiBoldItalic}) format('truetype');
    font-weight: 600;
    font-style: italic;
  }

  @font-face {
    font-family: 'NotoSans';
    src: local('NotoSans'), url(${NotoSansBold}) format('truetype');
    font-weight: 700;
    font-style: normal;
  }

  @font-face {
    font-family: 'NotoSans';
    src: local('NotoSans'), url(${NotoSansBoldItalic}) format('truetype');
    font-weight: 700;
    font-style: italic;
  }

`;
